import React from 'react';
import { Modal, Table, Tag, Typography } from 'antd';
import { UserDiscountCoupon } from '../../models/user-discount-coupon';

const { Text } = Typography;

interface UsedCouponsModalProps {
  visible: boolean;
  onClose: () => void;
  usedCoupons: UserDiscountCoupon[];
}

const UsedCouponsModal: React.FC<UsedCouponsModalProps> = ({ visible, onClose, usedCoupons }) => {
  const columns = [
    {
      title: '쿠폰명',
      dataIndex: ['couponInfo', 'name'],
      key: 'name',
      render: (name: string) => <Text strong>{name}</Text>,
    },
    {
      title: '할인 유형',
      dataIndex: ['couponInfo', 'discountType'],
      key: 'discountType',
      render: (type: string) => (
        <Tag color={type === 'percentage' ? 'blue' : 'green'}>
          {type === 'percentage' ? '퍼센트 할인' : '고정 금액'}
        </Tag>
      ),
    },
    {
      title: '할인 금액/율',
      key: 'discountValue',
      render: (record: UserDiscountCoupon) => {
        const { discountType, discountAmount, discountPercent, maxDiscountAmount } = record.couponInfo;

        if (discountType === 'percentage') {
          return (
            <div>
              <Text>{discountPercent}%</Text>
              {maxDiscountAmount && (
                <div style={{ fontSize: '12px', color: '#666' }}>(최대 {maxDiscountAmount.toLocaleString()}원)</div>
              )}
            </div>
          );
        } else {
          return <Text>{discountAmount?.toLocaleString()}원</Text>;
        }
      },
    },
    {
      title: '최소 주문 금액',
      dataIndex: ['couponInfo', 'minPurchaseAmount'],
      key: 'minPurchaseAmount',
      render: (amount: number) => <Text>{amount ? `${amount.toLocaleString()}원 이상` : '제한 없음'}</Text>,
    },
    {
      title: '상태',
      dataIndex: ['status'],
      key: 'minPurchaseAmount',
      render: (status: string) => (
        <Text>{status === 'used' ? '사용됨' : status === 'canceled' ? '사용취소' : '미사용'}</Text>
      ),
    },
  ];

  return (
    <Modal title="사용된 쿠폰 정보" open={visible} onCancel={onClose} footer={null} width={800} centered>
      {usedCoupons && usedCoupons.length > 0 ? (
        <div>
          <div style={{ marginBottom: 16 }}>
            <Text type="secondary">총 {usedCoupons.length}개의 쿠폰이 사용되었습니다.</Text>
          </div>
          <Table
            columns={columns}
            dataSource={usedCoupons}
            rowKey="_id"
            pagination={false}
            size="small"
            scroll={{ x: 600 }}
          />
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Text type="secondary">사용된 쿠폰이 없습니다.</Text>
        </div>
      )}
    </Modal>
  );
};

export default UsedCouponsModal;
